"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ChartIcon = function ChartIcon(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: "31px",
    height: "30px",
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, _react["default"].createElement("polyline", {
    className: "cls-1 hvr-icon-stroke",
    points: "23.96 14 17.96 22 13.96 12 8.02 20",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("circle", {
    className: "cls-2 hvr-icon-fill",
    cx: "25.96",
    cy: "11",
    r: "1.25",
    transform: "translate(-0.18 21.58) rotate(-45)",
    fill: "#fff"
  }), _react["default"].createElement("polyline", {
    className: "cls-1 hvr-icon-stroke",
    points: "4.97 7 4.97 27.01 26.96 27.01",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }));
};

var _default = ChartIcon;
exports["default"] = _default;